import { ListView } from "@/react/components/shared/MembersList/CommunityMembers/ListView/ListView";
import { Loader } from "@/react/components/shared/uikit/Loader";
import { useAudienceInfiniteQuery } from "@/react/hooks/useAudienceInfiniteQuery";

const activeConnectionsFilter = {
  id: "connections-active",
  key: "connections",
  status: "active",
};

export const MyConnections = () => {
  const allConnectionsQuery = useAudienceInfiniteQuery({
    filters: [activeConnectionsFilter],
    perPage: 10,
  });

  const listviewParams = {
    ...allConnectionsQuery,
    dataLength: allConnectionsQuery.totalQueryAudience,
    totalMembers: allConnectionsQuery.totalAudience,
    members: allConnectionsQuery.audience,
    isActiveQuery: true,
  };

  if (allConnectionsQuery.isLoading) {
    return <Loader />;
  }

  return (
    <ListView
      memberDataParams={listviewParams}
      shouldShowHiddenMemberTooltip={false}
      shouldShowConnectionStatus={false}
    />
  );
};
